import React from 'react';
import PropTypes from 'prop-types';

import Image from '../../components/Image';

const displayImageWidth = 493;
const displayImageHeight = 420;
const imageButtonWidth = 108;
const imageButtonHeight = 124;

export default class ImageCollection extends React.Component {
  static propTypes = {
    images: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.onKeyDown = this.onKeyDown.bind(this);

    this.state = {
      selectedImageIndex: 0,
    };
  }

  componentWillMount() {
    document.addEventListener("keydown", this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  componentWillUpdate(nextProps) {
    if (this.props.images !== nextProps.images) {
      this.setState({
        selectedImageIndex: 0
      });
    }
  }

  onKeyDown(event) {
    let selectedImageIndex = this.state.selectedImageIndex;
    if (event.key === "ArrowRight") {
      selectedImageIndex++;
    }
    if (event.key === "ArrowLeft") {
      selectedImageIndex--;
    }

    if (selectedImageIndex >= this.props.images.length) selectedImageIndex = this.props.images.length - 1;
    if (selectedImageIndex < 0) selectedImageIndex = 0;

    this.setState({ selectedImageIndex });
  }

  render() {
    if (!this.props.images) return null;
    // Creates an array with all the image URLs for this product
    let imageArray = this.props.images.map((image, index) =>
      <Image
        key={`product-image-${index}`}
        className={'img' + (index === this.state.selectedImageIndex ? ' active' : '')}
        stretchAndCrop={true}
        width={displayImageWidth}
        height={displayImageHeight}
        image={image}
      />
    );

    let imageButtons = this.props.images.map((image, index) =>
      <Image
        key={'product-image-button-' + index}
        className={'img img-button link'+ (index === this.state.selectedImageIndex ? ' selected' : '')}
        stretchAndCrop={true}
        image={image}
        width={imageButtonWidth}
        height={imageButtonHeight}
        onClick={() => this.setState({ selectedImageIndex: index })}
      />
    );

    return (
      <div className="product-images">
        <div className="image-display">{imageArray}</div>
        <div className="image-listing">{imageButtons}</div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/ProductModal/image_collection.js
 **/